import { render, staticRenderFns } from "./AddDependentsOffline.vue?vue&type=template&id=0ec3bae5&"
import script from "./AddDependentsOffline.vue?vue&type=script&lang=js&"
export * from "./AddDependentsOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports